import type { Icon } from 'ngxi'

export const oiAccountLogin: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M3 0v1h4v5H3v1h5V0zm1 2v1H0v1h4v1l2-1.5z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiAccountLogout: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M3 0v1h4v5H3v1h5V0zM2 2L0 3.5L2 5V4h4V3H2z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiActionRedo: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M3.5 1C1.57 1 0 2.57 0 4.5a2.5 2.5 0 0 1 5 0V5H4l2 2l2-2H7v-.5C7 2.57 5.43 1 3.5 1\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiActionUndo: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M4.5 1C2.57 1 1 2.57 1 4.5V5H0l2 2l2-2H3v-.5a2.5 2.5 0 0 1 5 0C8 2.57 6.43 1 4.5 1\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiAlignCenter: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M0 0v1h8V0zm1 2v1h6V2zM0 4v1h8V4zm1 2v1h6V6z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiAlignLeft: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M0 0v1h8V0zm0 2v1h6V2zm0 2v1h8V4zm0 2v1h6V6z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiAlignRight: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M0 0v1h8V0zm2 2v1h6V2zM0 4v1h8V4zm2 2v1h6V6z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiAperture: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M4 0c-.69 0-1.34.19-1.91.5l3.22 2.34l.75-2.25C5.46.23 4.75 0 4 0M1.25 1.13C.49 1.86 0 2.87 0 4.01c0 .25.02.48.06.72l3.09-2.22l-1.91-1.38zm5.63.13L5.66 5.01h2.19c.08-.32.16-.65.16-1c0-1.07-.44-2.03-1.13-2.75M2.16 4.48L.41 5.73c.55 1.13 1.6 1.99 2.88 2.22zm1.56 1.53l.63 1.97c1.33-.12 2.46-.88 3.09-1.97z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiArrowBottom: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M3 0v5H1l2.53 3L6 5H4V0z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiArrowCircleBottom: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M4 0C1.79 0 0 1.79 0 4s1.79 4 4 4s4-1.79 4-4s-1.79-4-4-4M3 1h2v3h2L4 7L1 4h2z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiArrowCircleLeft: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M4 0C1.79 0 0 1.79 0 4s1.79 4 4 4s4-1.79 4-4s-1.79-4-4-4m0 1v2h3v2H4v2L1 4z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiArrowCircleRight: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M4 0C1.79 0 0 1.79 0 4s1.79 4 4 4s4-1.79 4-4s-1.79-4-4-4m0 1l3 3l-3 3V5H1V3h3z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiArrowCircleTop: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M4 0C1.79 0 0 1.79 0 4s1.79 4 4 4s4-1.79 4-4s-1.79-4-4-4m0 1l3 3H5v3H3V4H1z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiArrowLeft: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M3 1L0 3.53L3 6V4h5V3H3z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiArrowRight: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M5 1v2H0v1h5v2l3-2.53z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiArrowThickBottom: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M3 0v5H1l3.03 3L7 5H5V0z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiArrowThickLeft: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M3 1L0 4.03L3 7V5h5V3H3z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiArrowThickRight: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M5 1v2H0v2h5v2l3-3.03z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiArrowThickTop: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M3.97 0L1 3h2v5h2V3h2z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiArrowTop: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M3.47 0L1 3h2v5h1V3h2z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiAudio: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M1.16 1C.44 1.72 0 2.71 0 3.81s.43 2.12 1.16 2.84l.72-.72C1.34 5.39 1 4.64 1 3.8c0-.83.33-1.55.88-2.09L1.16.99zm5.69 0l-.72.72c.54.54.88 1.26.88 2.09s-.33 1.58-.88 2.13l.72.72c.72-.72 1.16-1.74 1.16-2.84s-.43-2.09-1.16-2.81zM2.6 2.41c-.36.36-.59.86-.59 1.41s.23 1.08.59 1.44l.69-.72c-.18-.18-.28-.44-.28-.72s.1-.5.28-.69zm2.81 0l-.69.72c.18.18.28.41.28.69s-.1.54-.28.72l.69.72c.36-.36.59-.89.59-1.44s-.23-1.05-.59-1.41\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiAudioSpectrum: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M4 0v8h1V0zM2 1v6h1V1zm4 1v4h1V2zM0 3v2h1V3z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiBadge: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M4 0C2.9 0 2 .9 2 2s.9 2 2 2s2-.9 2-2s-.9-2-2-2M3 4.81V8l1-1l1 1V4.81c-.31.11-.65.19-1 .19s-.69-.08-1-.19\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiBan: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M4 0C1.8 0 0 1.8 0 4s1.8 4 4 4s4-1.8 4-4s-1.8-4-4-4m0 1c.66 0 1.26.21 1.75.56L1.56 5.75C1.21 5.26 1 4.66 1 4c0-1.66 1.34-3 3-3m2.44 1.25C6.79 2.74 7 3.34 7 4c0 1.66-1.34 3-3 3c-.66 0-1.26-.21-1.75-.56z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiBarChart: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M0 0v7h8V6H1V0zm5 0v5h2V0zM2 2v3h2V2z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiBasket: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M3.97 0c-.13.01-.26.08-.34.19L1.29 3H.01v1h1v3.66c0 .18.16.34.34.34h5.31c.18 0 .34-.16.34-.34V4h1V3H6.72C6.45 2.67 4.33.14 4.31.12c-.11-.09-.22-.14-.34-.13zM4 1.28L5.44 3H2.56zM2.5 5c.28 0 .5.22.5.5v1c0 .28-.22.5-.5.5S2 6.78 2 6.5v-1c0-.28.22-.5.5-.5m3 0c.28 0 .5.22.5.5v1c0 .28-.22.5-.5.5S5 6.78 5 6.5v-1c0-.28.22-.5.5-.5\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiBatteryEmpty: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M.09 1C.03 1 0 1.04 0 1.09V6.9c0 .05.04.09.09.09H6.9c.05 0 .09-.04.09-.09V4.99h1v-2h-1V1.08c0-.06-.04-.09-.09-.09H.09zM1 2h5v4H1z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiBatteryFull: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M.09 1C.03 1 0 1.04 0 1.09V6.9c0 .05.04.09.09.09H6.9c.05 0 .09-.04.09-.09V4.99h1v-2h-1V1.08c0-.06-.04-.09-.09-.09H.09z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiBeaker: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M1.34 0a.5.5 0 0 0 .16 1H2v1.41C1.91 2.58.8 4.72.34 5.5C.18 5.76 0 6.11 0 6.56c0 .39.15.77.41 1.03S1.05 8 1.44 8h5.13c.38 0 .74-.16 1-.41h.03c.26-.26.41-.64.41-1.03c0-.45-.19-.8-.34-1.06c-.46-.78-1.57-2.92-1.66-3.09V1h.5a.5.5 0 1 0 0-1h-5a.5.5 0 0 0-.09 0h-.06zM3 1h2v1.63l.06.09S5.69 3.95 6.25 5h-4.5c.56-1.05 1.19-2.28 1.19-2.28L3 2.63z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiBell: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M4 0C2.9 0 2 .9 2 2C2 3.04 1.48 3.98.66 4.66C.25 5 0 5.48 0 6h8c0-.52-.24-1-.66-1.34C6.52 3.98 6 3.04 6 2a2 2 0 0 0-2-2M3 7c0 .55.45 1 1 1s1-.45 1-1z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiBluetooth: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M2.5 0v2.5l-.75-.75L1 2.5L2.5 4L1 5.5l.75.75l.75-.75V8H3l3.5-2.5l-2.25-1.53L6.5 2.5L3 0zm1 1.5l1.5 1l-1.5 1zm0 3l1.5 1l-1.5 1z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiBold: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M0 0v1c.55 0 1 .45 1 1v4c0 .55-.45 1-1 1v1h5.5A2.5 2.5 0 0 0 8 5.5c0-1-.59-1.85-1.44-2.25A2 2 0 0 0 5 0zm3 1h1c.55 0 1 .45 1 1s-.45 1-1 1H3zm0 3h1.5C5.33 4 6 4.67 6 5.5S5.33 7 4.5 7H3z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiBolt: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M4 0L1 5h2v3l3-5H4z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiBook: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M1 0C.93 0 .87.01.81.03C.42.11.11.42.03.81C0 .87 0 .93 0 1v5.5C0 7.33.67 8 1.5 8H7V7H1.5c-.28 0-.5-.22-.5-.5s.22-.5.5-.5H7V.5c0-.28-.22-.5-.5-.5H6v3L5 2L4 3V0z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiBookmark: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M2 0v8l2-2l2 2V0z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiBox: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M0 0v1h8V0zm0 2v5.91c0 .05.04.09.09.09H7.9c.05 0 .09-.04.09-.09V2H5.02v1.03H2.99V2h-3z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiBriefcase: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M3 0c-.55 0-1 .45-1 1v1H.09C.03 2 0 2.04 0 2.09V4.5c0 .28.22.5.5.5h7c.28 0 .5-.22.5-.5V2.09C8 2.03 7.96 2 7.91 2H6V1c0-.55-.45-1-1-1zm0 1h2v1H3zM0 5.91v2c0 .05.04.09.09.09H7.9c.05 0 .09-.04.09-.09v-2c-.16.06-.32.09-.5.09h-7c-.18 0-.34-.04-.5-.09z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiBritishPound: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M4 0c-.62 0-1.16.26-1.5.69S2 1.68 2 2.25c0 .69.16 1.25.25 1.75H1v1h1.22c-.11.45-.37.96-1.06 1.66L1 6.79v1.22h6v-1H2.09c.64-.73.98-1.4 1.13-2H5v-1H3.28C3.2 3.33 3 2.77 3 2.26c0-.39.11-.73.28-.94s.37-.31.72-.31c.39 0 .61.11.75.25s.25.36.25.75h1c0-.58-.17-1.1-.53-1.47C5.1.17 4.58.01 4 .01z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiBrowser: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M.34 0A.5.5 0 0 0 0 .5v7a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5v-7a.5.5 0 0 0-.5-.5h-7a.5.5 0 0 0-.09 0H.35zM1.5 1c.28 0 .5.22.5.5s-.22.5-.5.5s-.5-.22-.5-.5s.22-.5.5-.5m2 0h3c.28 0 .5.22.5.5s-.22.5-.5.5h-3c-.28 0-.5-.22-.5-.5s.22-.5.5-.5M1 3h6v4H1z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiBrush: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M7.44.03c-.03 0-.04.02-.06.03L3.63 2.72c-.04.03-.1.11-.13.16l-.13.25c.72.23 1.27.78 1.5 1.5l.25-.13c.05-.03.12-.08.16-.13L7.94.62c.03-.05.04-.09 0-.13L7.5.05Q7.47.02 7.44.02zM2.66 4c-.74 0-1.31.61-1.31 1.34c0 .99-.55 1.85-1.34 2.31c.39.22.86.34 1.34.34c1.47 0 2.66-1.18 2.66-2.66c0-.74-.61-1.34-1.34-1.34z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiBug: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M3.5 0C2.31 0 1.52 1.69 2.31 2.5c-.09.07-.2.14-.28.22L.72 2.06A.5.5 0 0 0 .38 2a.5.5 0 0 0-.09.94l1.16.56c-.09.16-.19.33-.25.5H.51a.5.5 0 0 0-.09 0a.5.5 0 1 0 .09 1h.5q0 .345.06.66l-.78.41a.5.5 0 1 0 .44.88l.66-.34c.25.46.62.85 1.03 1.09c.35-.19.59-.44.59-.72V5.54a.5.5 0 0 0 0-.09v-.81a.5.5 0 0 0 0-.22c.05-.23.26-.41.5-.41c.28 0 .5.22.5.5v.88a.5.5 0 0 0 0 .09v.06a.5.5 0 0 0 0 .09v1.34c0 .27.24.53.59.72c.41-.25.79-.63 1.03-1.09l.66.34a.5.5 0 1 0 .44-.88l-.78-.41q.06-.315.06-.66h.5a.5.5 0 1 0 0-1h-.69c-.06-.17-.16-.34-.25-.5l1.16-.56a.5.5 0 0 0-.31-.94a.5.5 0 0 0-.13.06l-1.31.66c-.09-.08-.19-.15-.28-.22c.78-.83 0-2.5-1.19-2.5z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiBullhorn: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M6 0v6c.03.01.07 0 .09 0h.81c.05 0 .09-.04.09-.09V.1c0-.06-.04-.09-.09-.09h-.91zM5 .5L2.09 1.97c-.05.02-.13.03-.19.03H.09C.03 2 0 2.04 0 2.09V3.9c0 .06.04.09.09.09H1l1.03 2.72c.11.25.44.36.69.25s.36-.44.25-.69l-.75-1.78c.03-.14.13-.22.28-.22v-.03L5 5.49v-5z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiCalculator: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M.09 0C.03 0 0 .04 0 .09V7.9c0 .05.04.09.09.09H6.9c.05 0 .09-.04.09-.09V.09C6.99.03 6.95 0 6.9 0zM1 1h5v2H1zm0 3h1v1H1zm2 0h1v1H3zm2 0h1v3H5zM1 6h1v1H1zm2 0h1v1H3z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiCalendar: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M0 0v2h7V0zm0 3v4.91c0 .05.04.09.09.09H6.9c.05 0 .09-.04.09-.09V3h-7zm1 1h1v1H1zm2 0h1v1H3zm2 0h1v1H5zM1 6h1v1H1zm2 0h1v1H3z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiCameraSlr: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M4.09 0c-.05 0-.1.04-.13.09L3.02 1.9c-.02.05-.07.09-.13.09H1.48c-.83 0-1.5.67-1.5 1.5V7.9c0 .05.04.09.09.09h7.81c.05 0 .09-.04.09-.09V2.09c0-.06-.04-.09-.09-.09h-.81c-.05 0-.1-.04-.13-.09L6 .1C5.97.05 5.93.01 5.87.01H4.06zM1.5 3c.28 0 .5.22.5.5s-.22.5-.5.5s-.5-.22-.5-.5s.22-.5.5-.5M5 3c1.1 0 2 .9 2 2s-.9 2-2 2s-2-.9-2-2s.9-2 2-2m0 1c-.55 0-1 .45-1 1s.45 1 1 1s1-.45 1-1s-.45-1-1-1\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiCaretBottom: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m0 2l4 4l4-4z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiCaretLeft: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M6 0L2 4l4 4z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiCaretRight: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M2 0v8l4-4z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiCaretTop: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M4 2L0 6h8z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiCart: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M.34 1A.506.506 0 0 0 .5 2H2l.09.25l.41 1.25l.41 1.25c.04.13.21.25.34.25h3.5c.14 0 .3-.12.34-.25l.81-2.5c.04-.13-.02-.25-.16-.25H3.3l-.38-.72A.5.5 0 0 0 2.48 1h-2a.5.5 0 0 0-.09 0H.33zM3.5 6c-.28 0-.5.22-.5.5s.22.5.5.5s.5-.22.5-.5s-.22-.5-.5-.5m3 0c-.28 0-.5.22-.5.5s.22.5.5.5s.5-.22.5-.5s-.22-.5-.5-.5\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiChat: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M0 0v5l1-1h1V1h3V0zm3 2v4h4l1 1V2z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiCheck: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m6.41 1l-.69.72L2.94 4.5l-.81-.78L1.41 3L0 4.41l.72.72l1.5 1.5l.69.72l.72-.72l3.5-3.5l.72-.72z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiChevronBottom: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M1.5 1L0 2.5l4 4l4-4L6.5 1L4 3.5z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiChevronLeft: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M5 0L1 4l4 4l1.5-1.5L4 4l2.5-2.5z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiChevronRight: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M2.5 0L1 1.5L3.5 4L1 6.5L2.5 8l4-4z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiChevronTop: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M4 1L0 5l1.5 1.5L4 4l2.5 2.5L8 5z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiCircleCheck: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M4 0C1.79 0 0 1.79 0 4s1.79 4 4 4s4-1.79 4-4s-1.79-4-4-4m2 1.78l.72.72L3.5 5.72L1.78 4l.72-.72l1 1z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiCircleX: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M4 0C1.79 0 0 1.79 0 4s1.79 4 4 4s4-1.79 4-4s-1.79-4-4-4M2.5 1.78L4 3.28l1.5-1.5l.72.72L4.72 4l1.5 1.5l-.72.72L4 4.72l-1.5 1.5l-.72-.72L3.28 4l-1.5-1.5z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiClipboard: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M3.5 0c-.28 0-.5.22-.5.5V1h-.75c-.14 0-.25.11-.25.25V2h3v-.75C5 1.11 4.89 1 4.75 1H4V.5c0-.28-.22-.5-.5-.5M.25 1C.11 1 0 1.11 0 1.25v6.5c0 .14.11.25.25.25h6.5c.14 0 .25-.11.25-.25v-6.5C7 1.11 6.89 1 6.75 1H6v2H1V1z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiClock: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M4 0C1.8 0 0 1.8 0 4s1.8 4 4 4s4-1.8 4-4s-1.8-4-4-4m0 1c1.66 0 3 1.34 3 3S5.66 7 4 7S1 5.66 1 4s1.34-3 3-3m-.5 1v2.22l.16.13l.5.5l.34.38l.72-.72l-.38-.34l-.34-.34V2.02h-1z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiCloud: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M4.5 1C3.29 1 2.23 1.86 2 3C.9 3 0 3.9 0 5s.9 2 2 2h4.5C7.33 7 8 6.33 8 5.5c0-.65-.42-1.29-1-1.5v-.5A2.5 2.5 0 0 0 4.5 1\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiCloudDownload: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M4.5 0C3.29 0 2.23.86 2 2C.9 2 0 2.9 0 4c0 .37.11.71.28 1H3v-.5C3 3.67 3.67 3 4.5 3S6 3.67 6 4.5V5h1.91c.06-.16.09-.32.09-.5c0-.65-.42-1.29-1-1.5v-.5A2.5 2.5 0 0 0 4.5 0m-.16 4a.5.5 0 0 0-.34.5V6H2.5l2 2l2-2H5V4.5a.5.5 0 0 0-.59-.5h-.06z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiCloudUpload: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M4.5 0C3.29 0 2.23.86 2 2C.9 2 0 2.9 0 4c0 .37.11.71.28 1H2.5l2-2l2 2h1.41c.06-.16.09-.32.09-.5c0-.65-.42-1.29-1-1.5v-.5A2.5 2.5 0 0 0 4.5 0m0 4.5L2 7h2v.5a.5.5 0 1 0 1 0V7h2z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiCloudy: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M2.5 0A2.5 2.5 0 0 0 0 2.5c0 .39.09.74.25 1.06c.3-.21.64-.37 1-.47C1.8 1.84 3.07 1 4.5 1c-.46-.6-1.18-1-2-1m2 2C3.29 2 2.23 2.86 2 4C.9 4 0 4.9 0 6s.9 2 2 2h4.5C7.33 8 8 7.33 8 6.5c0-.65-.42-1.29-1-1.5v-.5A2.5 2.5 0 0 0 4.5 2\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiCode: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M5 1L2 7h1l3-6zM1 2L0 4l1 2h1L1 4l1-2zm5 0l1 2l-1 2h1l1-2l-1-2z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiCog: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M3.5 0L3 1.19c-.1.03-.19.08-.28.13L1.53.82l-.72.72l.5 1.19c-.05.1-.09.18-.13.28l-1.19.5v1l1.19.5c.04.1.08.18.13.28l-.5 1.19l.72.72l1.19-.5c.09.04.18.09.28.13l.5 1.19h1L5 6.83c.09-.04.19-.08.28-.13l1.19.5l.72-.72l-.5-1.19c.04-.09.09-.19.13-.28l1.19-.5v-1l-1.19-.5c-.03-.09-.08-.19-.13-.28l.5-1.19l-.72-.72l-1.19.5c-.09-.04-.19-.09-.28-.13L4.5 0zM4 2.5c.83 0 1.5.67 1.5 1.5S4.83 5.5 4 5.5S2.5 4.83 2.5 4S3.17 2.5 4 2.5\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiCollapseDown: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M0 0v2h8V0zm2 3l2 2l2-2zM0 7v1h8V7z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiCollapseLeft: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M0 0v8h1V0zm6 0v8h2V0zM5 2L3 4l2 2z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiCollapseRight: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M0 0v8h2V0zm7 0v8h1V0zM3 2v4l2-2z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiCollapseUp: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M0 0v1h8V0zm4 3L2 5h4zM0 6v2h8V6z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiCommand: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M1.5 0C.67 0 0 .67 0 1.5S.67 3 1.5 3H2v1h-.5C.67 4 0 4.67 0 5.5S.67 7 1.5 7S3 6.33 3 5.5V5h1v.5C4 6.33 4.67 7 5.5 7S7 6.33 7 5.5S6.33 4 5.5 4H5V3h.5C6.33 3 7 2.33 7 1.5S6.33 0 5.5 0S4 .67 4 1.5V2H3v-.5C3 .67 2.33 0 1.5 0m0 1c.28 0 .5.22.5.5V2h-.5c-.28 0-.5-.22-.5-.5s.22-.5.5-.5m4 0c.28 0 .5.22.5.5s-.22.5-.5.5H5v-.5c0-.28.22-.5.5-.5M3 3h1v1H3zM1.5 5H2v.5c0 .28-.22.5-.5.5S1 5.78 1 5.5s.22-.5.5-.5M5 5h.5c.28 0 .5.22.5.5s-.22.5-.5.5s-.5-.22-.5-.5z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiCommentSquare: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M.09 0C.03 0 0 .04 0 .09V5.9c0 .05.04.09.09.09H6l2 2V.08c0-.06-.04-.09-.09-.09H.1z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiCompass: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M4 0C1.8 0 0 1.8 0 4s1.8 4 4 4s4-1.8 4-4s-1.8-4-4-4m0 1c1.66 0 3 1.34 3 3S5.66 7 4 7S1 5.66 1 4s1.34-3 3-3m2 1L3 3L2 6l3-1zM4 3.5c.28 0 .5.22.5.5s-.22.5-.5.5s-.5-.22-.5-.5s.22-.5.5-.5\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiContrast: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M4 0C1.8 0 0 1.8 0 4s1.8 4 4 4s4-1.8 4-4s-1.8-4-4-4m0 1c1.66 0 3 1.34 3 3S5.66 7 4 7z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiCopywriting: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M0 0v1h8V0zm0 2v1h5V2zm0 3v1h8V5zm0 2v1h6V7zm7.5 0c-.28 0-.5.22-.5.5s.22.5.5.5s.5-.22.5-.5s-.22-.5-.5-.5\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiCreditCard: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M.25 1C.11 1 0 1.11 0 1.25V2h8v-.75C8 1.11 7.89 1 7.75 1zM0 3v3.75c0 .14.11.25.25.25h7.5c.14 0 .25-.11.25-.25V3zm1 2h1v1H1zm2 0h1v1H3z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiCrop: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M1 0v1H0v1h1v5h5v1h1V7h1V6H7V1.5l1-1l-.5-.5l-1 1H2V0zm1 2h3.5L2 5.5zm4 .5V6H2.5z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiDashboard: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M4 0C1.8 0 0 1.8 0 4s1.8 4 4 4s4-1.8 4-4s-1.8-4-4-4m0 1c1.66 0 3 1.34 3 3S5.66 7 4 7S1 5.66 1 4s1.34-3 3-3m0 1c-.28 0-.5.22-.5.5s.22.5.5.5s.5-.22.5-.5S4.28 2 4 2M2.34 3a.5.5 0 0 0-.19.84l.91.91C3.04 4.83 3 4.91 3 5c0 .55.45 1 1 1s1-.45 1-1s-.45-1-1-1c-.09 0-.17.04-.25.06l-.91-.91a.5.5 0 0 0-.44-.16h-.06zM5.5 3c-.28 0-.5.22-.5.5s.22.5.5.5s.5-.22.5-.5s-.22-.5-.5-.5\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiDataTransferDownload: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M3 0v3H1l3 3l3-3H5V0zM0 7v1h8V7z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiDataTransferUpload: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M0 0v1h8V0zm4 2L1 5h2v3h2V5h2z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiDelete: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M2 1L0 4l2 3h6V1zm1.5.78L5 3.28l1.5-1.5l.72.72L5.72 4l1.5 1.5l-.72.72L5 4.72l-1.5 1.5l-.72-.72L4.28 4l-1.5-1.5z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiDial: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M4 1C1.8 1 0 2.8 0 5h1c0-1.66 1.34-3 3-3s3 1.34 3 3h1c0-2.2-1.8-4-4-4m-.59 2.09A2 2 0 0 0 4 7c1.11 0 2-.89 2-2c0-.9-.59-1.65-1.41-1.91L4 3.97z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiDocument: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M0 0v8h7V4H3V0zm4 0v3h3zM1 2h1v1H1zm0 2h1v1H1zm0 2h4v1H1z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiDollar: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M3 0v1h-.75C1.57 1 1 1.57 1 2.25v.5c0 .68.44 1.24 1.09 1.41l2.56.66c.14.04.34.29.34.44v.5c0 .14-.11.25-.25.25h-2.5a.56.56 0 0 1-.25-.06v-.94h-1v1c0 .34.2.63.44.78c.23.16.52.22.81.22h.75v1h1v-1h.75c.69 0 1.25-.56 1.25-1.25v-.5c0-.68-.44-1.24-1.09-1.41l-2.56-.66C2.2 3.15 2 2.9 2 2.75v-.5c0-.14.11-.25.25-.25h2.5c.11 0 .21.04.25.06V3h1V2c0-.34-.2-.63-.44-.78c-.23-.16-.52-.22-.81-.22H4V0z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiDoubleQuoteSansLeft: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M0 1v6l3-3V1zm5 0v6l3-3V1z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiDoubleQuoteSansRight: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M3 1L0 4v3h3zm5 0L5 4v3h3z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiDoubleQuoteSerifLeft: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M3 1C1.35 1 0 2.35 0 4v3h3V4H1c0-1.11.89-2 2-2zm5 0C6.35 1 5 2.35 5 4v3h3V4H6c0-1.11.89-2 2-2z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiDoubleQuoteSerifRight: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M0 1v3h2c0 1.11-.89 2-2 2v1c1.65 0 3-1.35 3-3V1zm5 0v3h2c0 1.11-.89 2-2 2v1c1.65 0 3-1.35 3-3V1z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiDroplet: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m4 0l-.34.34C3.55.45 1 3.03 1 5.22c0 1.65 1.35 3 3 3s3-1.35 3-3C7 3.04 4.45.45 4.34.34zM2.5 4.72c.28 0 .5.22.5.5c0 .55.45 1 1 1c.28 0 .5.22.5.5s-.22.5-.5.5c-1.1 0-2-.9-2-2c0-.28.22-.5.5-.5\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiEject: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M4 0L0 5h8zM0 6v2h8V6z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiElevator: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M4 0L1 3h6zM1 5l3 3l3-3z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiEllipses: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M0 3v2h2V3zm3 0v2h2V3zm3 0v2h2V3z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiEnvelopeClosed: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M0 1v1l4 2l4-2V1zm0 2v4h8V3L4 5z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiEnvelopeOpen: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M4 0L0 2v6h8V2zm0 1.13l3 1.5v1.88l-3 1.5l-3-1.5V2.63zM2 3.01v1l2 1l2-1v-1z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiEuro: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M5 0C3.14 0 1.6 1.28 1.16 3H-.75L-1 4h2.01c0 .35.07.68.16 1H-.8l-.19 1h2.56c.7 1.19 1.97 2 3.44 2c.73 0 1.41-.21 2-.56V6.22c-.53.48-1.22.78-2 .78c-.89 0-1.67-.39-2.22-1h2.22l.16-1H2.2a3 3 0 0 1-.19-1h3.34l.16-1H2.2a2.988 2.988 0 0 1 4.56-1.44L6.92.5C6.35.19 5.71 0 5.01 0z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiExcerpt: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M0 0v1h7V0zm0 2v1h5V2zm0 2v1h8V4zm0 2v1h1V6zm2 0v1h1V6zm2 0v1h1V6z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiExpandDown: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M0 0v1h8V0zm2 2l2 2l2-2zM0 6v2h8V6z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiExpandLeft: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M0 0v8h1V0zm6 0v8h2V0zM2 2v4l2-2z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiExpandRight: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M0 0v8h2V0zm7 0v8h1V0zM6 2L4 4l2 2z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiExpandUp: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M0 0v2h8V0zm4 4L2 6h4zM0 7v1h8V7z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiExternalLink: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M0 0v8h8V6H7v1H1V1h1V0zm4 0l1.5 1.5L3 4l1 1l2.5-2.5L8 4V0z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiEye: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M4.03 1C1.5 1 0 4 0 4s1.5 3 4.03 3C6.5 7 8 4 8 4S6.5 1 4.03 1M4 2a2 2 0 0 1 2 2c0 1.11-.89 2-2 2a2 2 0 1 1 0-4m0 1c-.55 0-1 .45-1 1s.45 1 1 1s1-.45 1-1c0-.1-.04-.19-.06-.28a.495.495 0 1 1-.66-.66A.9.9 0 0 0 4 3\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiEyedropper: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M3.31 0a.5.5 0 0 0-.19.84l.63.63L.16 5.13L0 5.29v2.72h2.69l.16-.16l3.66-3.66l.63.66a.5.5 0 1 0 .72-.69l-.94-.94l.66-.66c.59-.58.59-1.54 0-2.13c-.57-.57-1.56-.57-2.13 0l-.66.66l-.94-.94a.5.5 0 0 0-.47-.16h-.06zm1.16 2.19L5.78 3.5L2.62 6.66L1.34 5.35z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiFile: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M0 0v8h7V4H3V0zm4 0v3h3z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiFire: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M2 0c1 2-2 3-2 5s2 3 2 3c-.98-1.98 2-3 2-5S2 0 2 0m3 3c1 2-2 3-2 5h3c.4 0 1-.5 1-2c0-2-2-3-2-3\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiFlag: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M0 0v8h1V0zm2 0v4h2v1h4L6 3.03L8 1H5V0z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiFlash: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M3.5 0L2 3h2l-.66 2H2l1 3l3-3H4.5L6 2H4l1-2z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiFolder: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M0 0v2h8V1H3V0zm0 3v4.5c0 .28.22.5.5.5h7c.28 0 .5-.22.5-.5V3z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiFork: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M1.5 0C.67 0 0 .67 0 1.5c0 .66.41 1.2 1 1.41V5.1c-.59.2-1 .75-1 1.41c0 .83.67 1.5 1.5 1.5S3 7.34 3 6.51c0-.6-.34-1.1-.84-1.34c.09-.09.21-.16.34-.16h2c.82 0 1.5-.68 1.5-1.5v-.59c.59-.2 1-.75 1-1.41C7 .68 6.33.01 5.5.01S4 .68 4 1.51c0 .66.41 1.2 1 1.41v.59c0 .28-.22.5-.5.5h-2c-.17 0-.35.04-.5.09V2.91c.59-.2 1-.75 1-1.41C3 .67 2.33 0 1.5 0\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiFullscreenEnter: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M0 0v4l1.5-1.5L3 4l1-1l-1.5-1.5L4 0zm5 4L4 5l1.5 1.5L4 8h4V4L6.5 5.5z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiFullscreenExit: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M1 0L0 1l1.5 1.5L0 4h4V0L2.5 1.5zm3 4v4l1.5-1.5L7 8l1-1l-1.5-1.5L8 4z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiGlobe: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M4 0C1.79 0 0 1.79 0 4s1.79 4 4 4s4-1.79 4-4s-1.79-4-4-4m0 1c.33 0 .64.09.94.19c-.21.2-.45.38-.41.56s.69.13.69.5c0 .27-.42.35-.13.66c.35.35-.64.98-.66 1.44c-.03.83.84.97 1.53.97c.42 0 .53.2.5.44c-.54.77-1.46 1.25-2.47 1.25c-.38 0-.73-.09-1.06-.22c.22-.44-.28-1.31-.75-1.59c-.23-.23-.72-.14-1-.25c-.09-.27-.18-.54-.19-.84c.03-.05.08-.09.16-.09c.19 0 .45.38.59.34c.18-.04-.74-1.31-.31-1.56c.2-.12.6.39.47-.16c-.12-.51.36-.28.66-.41c.26-.11.45-.41.13-.59c-.06-.03-.13-.1-.22-.19c.45-.27.97-.44 1.53-.44zm2.31 1.09c.18.22.32.46.44.72v.03c-.04.07-.11.11-.22.22c-.28.28-.32-.21-.44-.31c-.13-.12-.6.02-.66-.13c-.07-.18.5-.42.88-.53\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiGraph: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M7.03 0L4 3L3 2L0 5.03l1 1L3 4l1 1l4-4zM0 7v1h8V7z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiGridFourUp: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M0 0v1h1V0zm2 0v1h1V0zm2 0v1h1V0zm2 0v1h1V0zM0 2v1h1V2zm2 0v1h1V2zm2 0v1h1V2zm2 0v1h1V2zM0 4v1h1V4zm2 0v1h1V4zm2 0v1h1V4zm2 0v1h1V4zM0 6v1h1V6zm2 0v1h1V6zm2 0v1h1V6zm2 0v1h1V6z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiGridThreeUp: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M0 0v2h2V0zm3 0v2h2V0zm3 0v2h2V0zM0 3v2h2V3zm3 0v2h2V3zm3 0v2h2V3zM0 6v2h2V6zm3 0v2h2V6zm3 0v2h2V6z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiGridTwoUp: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M0 0v3h3V0zm5 0v3h3V0zM0 5v3h3V5zm5 0v3h3V5z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiHardDrive: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M.19 0C.08 0 0 .08 0 .19V3.5c0 .28.22.5.5.5h6c.28 0 .5-.22.5-.5V.19C7 .08 6.92 0 6.81 0H.18zM0 4.91v2.91c0 .11.08.19.19.19h6.63c.11 0 .19-.08.19-.19V4.91c-.16.06-.32.09-.5.09h-6c-.18 0-.34-.04-.5-.09zM5.5 6c.28 0 .5.22.5.5s-.22.5-.5.5s-.5-.22-.5-.5s.22-.5.5-.5\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiHeader: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M0 0v1h.5c.28 0 .5.22.5.5v4c0 .28-.22.5-.5.5H0v1h3V6h-.5c-.28 0-.5-.22-.5-.5V4h3v1.5c0 .28-.22.5-.5.5H4v1h3V6h-.5c-.28 0-.5-.22-.5-.5v-4c0-.28.22-.5.5-.5H7V0H4v1h.5c.28 0 .5.22.5.5V3H2V1.5c0-.28.22-.5.5-.5H3V0z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiHeadphones: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M4 0C2.35 0 1 1.35 1 3v1H.5a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5V3c0-1.11.89-2 2-2s2 .89 2 2v3.5a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 0-.5-.5H7V3c0-1.65-1.35-3-3-3\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiHeart: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M2 1c-.55 0-1.04.23-1.41.59C.23 1.95 0 2.44 0 3c0 .55.23 1.04.59 1.41L4 7.82l3.41-3.41C7.77 4.05 8 3.56 8 3c0-.55-.23-1.04-.59-1.41C7.05 1.23 6.56 1 6 1c-.55 0-1.04.23-1.41.59C4.23 1.95 4 2.44 4 3c0-.55-.23-1.04-.59-1.41C3.05 1.23 2.56 1 2 1\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiHome: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M4 0L0 3h1v4h2V5h2v2h2V2.97L8 3z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiImage: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M0 0v8h8V0zm1 1h6v3L6 3L5 4l2 2v1H6L2 3L1 4z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiInbox: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M.19 0C.08 0 0 .08 0 .19v7.63c0 .11.08.19.19.19h7.63c.11 0 .19-.08.19-.19V.19c0-.11-.08-.19-.19-.19zM1 2h6v3H6L5 6H3L2 5H1z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiInfinity: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M2 2C.69 2 0 3.01 0 4s.69 2 2 2c.79 0 1.42-.56 2-1.22C4.58 5.44 5.19 6 6 6c1.31 0 2-1.01 2-2s-.69-2-2-2c-.81 0-1.42.56-2 1.22C3.42 2.56 2.79 2 2 2m0 1c.42 0 .88.47 1.34 1c-.46.53-.92 1-1.34 1c-.74 0-1-.54-1-1s.26-1 1-1m4 0c.74 0 1 .54 1 1s-.26 1-1 1c-.43 0-.89-.47-1.34-1c.46-.53.91-1 1.34-1\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiInfo: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M5 0c-.55 0-1 .45-1 1s.45 1 1 1s1-.45 1-1s-.45-1-1-1M3.5 2.5C2.67 2.5 2 3.17 2 4h1c0-.28.22-.5.5-.5s.5.22.5.5s-1 1.64-1 2.5S3.67 8 4.5 8S6 7.33 6 6.5H5c0 .28-.22.5-.5.5S4 6.78 4 6.5C4 6.14 5 4.66 5 4c0-.81-.67-1.5-1.5-1.5\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiItalic: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M2 0v1h1.63l-.06.13l-2 5l-.34.88H.01v1h5v-1H3.38l.06-.13l2-5L5.78 1H7V0z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiJustifyCenter: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M0 0v1h8V0zm0 2v1h8V2zm0 2v1h8V4zm1 2v1h6V6z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiJustifyLeft: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M0 0v1h8V0zm0 2v1h8V2zm0 2v1h8V4zm0 2v1h6V6z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiJustifyRight: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M0 0v1h8V0zm0 2v1h8V2zm0 2v1h8V4zm2 2v1h6V6z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiKey: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M5.5 0A2.5 2.5 0 0 0 3 2.5c0 .16 0 .32.03.47L0 6v2h3V6h2V5l.03-.03c.15.03.31.03.47.03a2.5 2.5 0 0 0 0-5M6 1c.55 0 1 .45 1 1s-.45 1-1 1s-1-.45-1-1s.45-1 1-1\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiLaptop: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M1.34 1a.5.5 0 0 0-.34.5V5H0v1.5c0 .28.22.5.5.5h7.01c.28 0 .5-.22.5-.5V5h-1V1.5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0-.09 0h-.06zM2 2h4v3H5v1H3V5H2z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiLayers: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M0 0v4h4V0zm5 2v3H2v1h4V2zm2 2v3H4v1h4V4z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiLightbulb: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M4.41 0a.5.5 0 0 0-.13.06l-3 1.5a.5.5 0 1 0 .44.88l3-1.5A.5.5 0 0 0 4.41 0m1 1.5a.5.5 0 0 0-.13.06l-4 2a.5.5 0 1 0 .44.88l4-2a.5.5 0 0 0-.31-.94m0 2a.5.5 0 0 0-.13.06l-3 1.5A.5.5 0 0 0 2.5 6h2a.506.506 0 0 0 .16-1l1.06-.56a.5.5 0 0 0-.31-.94M2.85 7a.506.506 0 0 0 .16 1h1a.5.5 0 1 0 0-1h-1a.5.5 0 0 0-.09 0h-.06z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiLinkBroken: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M2 0v1H1v1h2V0zm3.88.03a2 2 0 0 0-.53.09c-.27.1-.53.25-.75.47l-.44.44a.5.5 0 1 0 .69.69l.44-.44c.11-.11.24-.17.38-.22c.35-.12.78-.07 1.06.22c.39.39.39 1.04 0 1.44l-1.5 1.5a.5.5 0 1 0 .69.69l1.5-1.5A1.98 1.98 0 0 0 6.45.07C6.27.03 6.07.03 5.89.04zM2.29 2.94a.5.5 0 0 0-.19.16L.6 4.6a1.98 1.98 0 0 0 0 2.81c.56.56 1.36.72 2.06.47c.27-.1.53-.25.75-.47l.44-.44a.5.5 0 1 0-.69-.69l-.44.44c-.11.11-.24.17-.38.22c-.35.12-.78.07-1.06-.22c-.39-.39-.39-1.04 0-1.44l1.5-1.5a.5.5 0 0 0-.44-.84h-.06zM5.01 6v2h1V7h1V6z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiLinkIntact: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M5.88.03a2 2 0 0 0-.53.09c-.27.1-.53.25-.75.47a.5.5 0 1 0 .69.69c.11-.11.24-.17.38-.22c.35-.12.78-.07 1.06.22c.39.39.39 1.04 0 1.44l-1.5 1.5c-.44.44-.8.48-1.06.47s-.41-.13-.41-.13a.5.5 0 1 0-.5.88s.34.22.84.25s1.2-.16 1.81-.78l1.5-1.5A1.98 1.98 0 0 0 6.44.07C6.26.03 6.06.03 5.88.04zm-2 2.31c-.5-.02-1.19.15-1.78.75L.6 4.59a1.98 1.98 0 0 0 0 2.81c.56.56 1.36.72 2.06.47c.27-.1.53-.25.75-.47a.5.5 0 1 0-.69-.69c-.11.11-.24.17-.38.22c-.35.12-.78.07-1.06-.22c-.39-.39-.39-1.04 0-1.44l1.5-1.5c.4-.4.75-.45 1.03-.44s.47.09.47.09a.5.5 0 1 0 .44-.88s-.34-.2-.84-.22z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiList: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M.5 0C.22 0 0 .22 0 .5s.22.5.5.5s.5-.22.5-.5S.78 0 .5 0M2 0v1h6V0zM.5 2c-.28 0-.5.22-.5.5s.22.5.5.5s.5-.22.5-.5S.78 2 .5 2M2 2v1h6V2zM.5 4c-.28 0-.5.22-.5.5s.22.5.5.5s.5-.22.5-.5S.78 4 .5 4M2 4v1h6V4zM.5 6c-.28 0-.5.22-.5.5s.22.5.5.5s.5-.22.5-.5S.78 6 .5 6M2 6v1h6V6z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiListRich: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M0 0v3h3V0zm4 0v1h4V0zm0 2v1h3V2zM0 4v3h3V4zm4 0v1h4V4zm0 2v1h3V6z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiLocation: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M8 0L0 4l3 1l1 3z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiLockLocked: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M4 0C2.9 0 2 .9 2 2v1H1v4h6V3H6V2c0-1.1-.9-2-2-2m0 1c.56 0 1 .44 1 1v1H3V2c0-.56.44-1 1-1\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiLockUnlocked: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M4 0C2.9 0 2 .9 2 2h1c0-.56.44-1 1-1s1 .44 1 1v2H1v4h6V4H6V2c0-1.1-.9-2-2-2\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiLoop: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M6 0v1H1c-.55 0-1 .45-1 1v1h1V2h5v1l2-1.5zM2 4L0 5.5L2 7V6h5c.55 0 1-.45 1-1V4H7v1H2z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiLoopCircular: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M4 1C2.35 1 1 2.35 1 4H0l1.5 2L3 4H2c0-1.11.89-2 2-2zm2.5 1L5 4h1c0 1.11-.89 2-2 2v1c1.65 0 3-1.35 3-3h1z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiLoopSquare: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M1 0v2h1V1h4v2H5l1.5 2.5L8 3H7V0zm.5 2.5L0 5h1v3h6V6H6v1H2V5h1z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiMagnifyingGlass: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M3.5 0C1.57 0 0 1.57 0 3.5S1.57 7 3.5 7c.59 0 1.17-.14 1.66-.41a1 1 0 0 0 .13.13l1 1a1.02 1.02 0 1 0 1.44-1.44l-1-1a1 1 0 0 0-.16-.13c.27-.49.44-1.06.44-1.66c0-1.93-1.57-3.5-3.5-3.5zm0 1C4.89 1 6 2.11 6 3.5c0 .66-.24 1.27-.66 1.72l-.03.03a1 1 0 0 0-.13.13c-.44.4-1.04.63-1.69.63c-1.39 0-2.5-1.11-2.5-2.5s1.11-2.5 2.5-2.5z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiMap: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M0 0v8h8V5.62a.5.5 0 0 0 0-.22V-.01H0zm1 1h6v4H5.5a.5.5 0 0 0-.09 0a.5.5 0 1 0 .09 1H7v1H1zm2.5 1C2.67 2 2 2.67 2 3.5C2 4.5 3.5 6 3.5 6S5 4.5 5 3.5C5 2.67 4.33 2 3.5 2m0 1c.28 0 .5.22.5.5s-.22.5-.5.5s-.5-.22-.5-.5s.22-.5.5-.5\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiMapMarker: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M4 0C2.34 0 1 1.34 1 3c0 2 3 5 3 5s3-3 3-5c0-1.66-1.34-3-3-3m0 1a2 2 0 0 1 2 2c0 1.11-.89 2-2 2a2 2 0 1 1 0-4\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiMediaPause: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M1 1v6h2V1zm4 0v6h2V1z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiMediaPlay: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M1 1v6l6-3z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiMediaRecord: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M4 1C2.34 1 1 2.34 1 4s1.34 3 3 3s3-1.34 3-3s-1.34-3-3-3\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiMediaSkipBackward: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M4 1L0 4l4 3zm0 3l4 3V1z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiMediaSkipForward: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M0 1v6l4-3zm4 3v3l4-3l-4-3z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiMediaStepBackward: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M0 1v6h2V1zm2 3l5 3V1z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiMediaStepForward: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M0 1v6l5-3zm5 3v3h2V1H5z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiMediaStop: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M1 1v6h6V1z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiMedicalCross: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M2 0v2H0v4h2v2h4V6h2V2H6V0z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiMenu: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M0 1v1h8V1zm0 2.97v1h8v-1zm0 3v1h8v-1z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiMicrophone: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M3.91-.03a1 1 0 0 0-.13.03A1 1 0 0 0 3 1v2a1 1 0 1 0 2 0V1A1 1 0 0 0 3.91-.03M1.35 2a.5.5 0 0 0-.34.5V3c0 1.48 1.09 2.69 2.5 2.94V7h-.5c-.55 0-1 .45-1 1h4.01c0-.55-.45-1-1-1h-.5V5.94C5.93 5.7 7.02 4.48 7.02 3v-.5a.5.5 0 1 0-1 0V3c0 1.11-.89 2-2 2s-2-.89-2-2v-.5a.5.5 0 0 0-.59-.5h-.06z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiMinus: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M0 3v2h8V3z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiMonitor: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M.34 0A.5.5 0 0 0 0 .5v5a.5.5 0 0 0 .5.5H3v1H2c-.55 0-1 .45-1 1h6c0-.55-.45-1-1-1H5V6h2.5a.5.5 0 0 0 .5-.5v-5a.5.5 0 0 0-.5-.5h-7a.5.5 0 0 0-.09 0H.35zM1 1h6v4H1z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiMoon: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M2.72 0A3.99 3.99 0 0 0 0 3.78c0 2.21 1.79 4 4 4c1.76 0 3.25-1.14 3.78-2.72c-.4.13-.83.22-1.28.22c-2.21 0-4-1.79-4-4c0-.45.08-.88.22-1.28\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiMove: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M3.5 0L2 1.5h1V3H1.5V2L0 3.5L1.5 5V4H3v1.5H2L3.5 7L5 5.5H4V4h1.5v1L7 3.5L5.5 2v1H4V1.5h1z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiMusicalNote: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M8 0C3 0 2 1 2 1v4.09A1.6 1.6 0 0 0 1.5 5C.67 5 0 5.67 0 6.5S.67 8 1.5 8S3 7.33 3 6.5V2.53c.73-.23 1.99-.44 4-.5v2.06A1.6 1.6 0 0 0 6.5 4C5.67 4 5 4.67 5 5.5S5.67 7 6.5 7S8 6.33 8 5.5z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiPaperclip: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M5 0c-.51 0-1.02.21-1.41.59L.81 3.31a2.746 2.746 0 0 0 0 3.88a2.746 2.746 0 0 0 3.88 0l1.25-1.25l-.69-.69l-1.16 1.13l-.09.13c-.69.69-1.81.69-2.5 0c-.68-.68-.66-1.78 0-2.47l2.78-2.75c.39-.39 1.04-.39 1.44 0c.39.39.37 1.01 0 1.41l-2.5 2.47c-.1.1-.27.1-.38 0c-.1-.1-.1-.27 0-.38l.06-.03l.91-.94l-.69-.69l-.97.97c-.48.48-.48 1.27 0 1.75s1.27.49 1.75 0l2.5-2.44c.78-.78.78-2.04 0-2.81C6.01.21 5.51.01 4.99.01z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiPencil: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M6 0L5 1l2 2l1-1zM4 2L0 6v2h2l4-4z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiPeople: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M5.5 0c-.51 0-.95.35-1.22.88c.45.54.72 1.28.72 2.13c0 .29-.03.55-.09.81c.19.11.38.19.59.19c.83 0 1.5-.9 1.5-2s-.67-2-1.5-2zm-3 1C1.67 1 1 1.9 1 3s.67 2 1.5 2S4 4.1 4 3s-.67-2-1.5-2m4.75 3.16c-.43.51-1.02.82-1.69.84c.27.38.44.84.44 1.34V7h2V5.34c0-.52-.31-.97-.75-1.19zm-6.5 1C.31 5.38 0 5.83 0 6.35v1.66h5V6.35c0-.52-.31-.97-.75-1.19C3.8 5.69 3.19 6 2.5 6S1.2 5.68.75 5.16\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiPerson: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M4 0C2.9 0 2 1.12 2 2.5S2.9 5 4 5s2-1.12 2-2.5S5.1 0 4 0M1.91 5C.85 5.05 0 5.92 0 7v1h8V7c0-1.08-.84-1.95-1.91-2c-.54.61-1.28 1-2.09 1s-1.55-.39-2.09-1\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiPhone: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M1.19 0C1.08 0 1 .08 1 .19v7.63c0 .11.08.19.19.19h4.63c.11 0 .19-.08.19-.19V.19c0-.11-.08-.19-.19-.19zM2 1h3v5H2zm1.5 5.5c.28 0 .5.22.5.5s-.22.5-.5.5S3 7.28 3 7s.22-.5.5-.5\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiPieChart: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M3.5 0c-.97 0-1.84.4-2.47 1.03L4 4V.03A4 4 0 0 0 3.5 0M5 1.06v3.41L2.28 7.19c.61.5 1.37.81 2.22.81C6.43 8 8 6.43 8 4.5c0-1.76-1.31-3.19-3-3.44M.91 2.37C.35 2.91 0 3.66 0 4.5c0 .96.46 1.79 1.16 2.34l2.13-2.13z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiPin: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M1.34 0a.5.5 0 0 0 .16 1H2v2H1c-.55 0-1 .45-1 1h3v3l.44 1L4 7V4h3c0-.55-.45-1-1-1H5V1h.5a.5.5 0 1 0 0-1h-4a.5.5 0 0 0-.09 0h-.06z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiPlayCircle: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M4 0C1.79 0 0 1.79 0 4s1.79 4 4 4s4-1.79 4-4s-1.79-4-4-4M3 2l3 2l-3 2z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiPlus: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M3 0v3H0v2h3v3h2V5h3V3H5V0z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiPowerStandby: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M3 0v4h1V0zM1.72 1.44l-.38.31C.53 2.39 0 3.39 0 4.5C0 6.43 1.57 8 3.5 8S7 6.43 7 4.5c0-1.11-.53-2.11-1.34-2.75l-.38-.31l-.63.78l.38.31C5.61 2.99 6 3.7 6 4.5C6 5.89 4.89 7 3.5 7S1 5.89 1 4.5c0-.8.36-1.51.94-1.97l.41-.31z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiPrint: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M2 0v2h4V0zM.09 3C.03 3 0 3.04 0 3.09V5.9c0 .05.04.09.09.09H1v-2h6v2h.91c.05 0 .09-.04.09-.09V3.09C8 3.03 7.96 3 7.91 3H.1zM2 5v3h4V5z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiProject: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M0 0v7h1V0zm7 0v7h1V0zM2 1v1h2V1zm1 2v1h2V3zm1 2v1h2V5z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiPulse: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m3.25 0l-.47 1.53L2 4.09l-.03-.06l-.09-.34H0v1h1.16l.38 1.16l.47 1.47l.47-1.5l.78-2.5l.78 2.5l.41 1.34l.53-1.28l.59-1.47l.13.28h2.31v-1H6.32l-.38-.75l-.5-.97L5.03 3l-.47 1.19l-.84-2.66z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiPuzzlePiece: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M3 0c-.28 0-.54.1-.72.28S2 .72 2 1s.18.48.28.72c.03.06.03.16.03.28H0v6h2.31c0-.12-.01-.22-.03-.28C2.18 7.48 2 7.28 2 7s.1-.54.28-.72S2.72 6 3 6s.54.1.72.28S4 6.72 4 7s-.18.48-.28.72c-.03.06-.03.16-.03.28H6V5.69c.12 0 .22.01.28.03c.24.1.44.28.72.28s.54-.1.72-.28S8 5.28 8 5s-.1-.54-.28-.72S7.28 4 7 4s-.48.18-.72.28c-.06.03-.16.03-.28.03V2H3.69c0-.12.01-.22.03-.28c.1-.24.28-.44.28-.72S3.9.46 3.72.28S3.28 0 3 0\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiQuestionMark: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M4.47 0c-.85 0-1.48.26-1.88.66s-.54.9-.59 1.28l1 .13c.04-.25.12-.5.31-.69S3.8 1 4.47 1c.66 0 1.02.16 1.22.34s.28.4.28.66c0 .83-.34 1.06-.84 1.5S3.97 4.58 3.97 5.75V6h1v-.25c0-.83.31-1.06.81-1.5S6.97 3.17 6.97 2c0-.48-.17-1.02-.59-1.41C5.95.2 5.31 0 4.47 0m-.5 7v1h1V7z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiRain: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M4.5 0C3.29 0 2.23.86 2 2C.9 2 0 2.9 0 4c0 .53.2.99.53 1.34c.26-.22.6-.34.97-.34c.2 0 .39.05.56.13C2.23 4.49 2.8 4 3.5 4c.69 0 1.27.49 1.44 1.13c.17-.07.36-.13.56-.13c.63 0 1.15.39 1.38.94c.64-.17 1.13-.75 1.13-1.44c0-.65-.42-1.29-1-1.5v-.5A2.5 2.5 0 0 0 4.51 0zM3.34 5a.5.5 0 0 0-.34.5v2a.5.5 0 1 0 1 0v-2a.5.5 0 0 0-.59-.5h-.06zm-2 1a.5.5 0 0 0-.34.5v1a.5.5 0 1 0 1 0v-1a.5.5 0 0 0-.59-.5h-.06zm4 0a.5.5 0 0 0-.34.5v1a.5.5 0 1 0 1 0v-1a.5.5 0 0 0-.59-.5h-.06z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiRandom: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M6 0v1h-.5c-.35 0-.56.1-.78.38L3.31 3.16L1.78 1.38C1.56 1.12 1.34 1 1 1H0v1h1c-.05 0 .01.04.03.03l1.63 1.91L1 6H0v1h1c.35 0 .56-.1.78-.38l1.53-1.91l1.66 1.91c.22.26.44.38.78.38H6v1l2-1.5L6 5v1h-.22c-.01-.01-.05-.04-.06-.03L3.97 3.91L5.5 2H6v1l2-1.5z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiReload: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M4 0C1.8 0 0 1.8 0 4s1.8 4 4 4c1.1 0 2.12-.43 2.84-1.16l-.72-.72c-.54.54-1.29.88-2.13.88c-1.66 0-3-1.34-3-3s1.34-3 3-3c.83 0 1.55.36 2.09.91L4.99 3h3V0L6.8 1.19C6.08.47 5.09 0 3.99 0z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiResizeBoth: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m4 0l1.66 1.66l-4 4L0 4v4h4L2.34 6.34l4-4L8 4V0z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiResizeHeight: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M3.5 0L1 3h2v2H1l2.5 3L6 5H4V3h2z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiResizeWidth: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M3 1L0 3.5L3 6V4h2v2l3-2.5L5 1v2H3z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiRss: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M1 0v1c3.32 0 6 2.68 6 6h1c0-3.86-3.14-7-7-7m0 2v1c2.21 0 4 1.79 4 4h1c0-2.76-2.24-5-5-5m0 2v1c1.11 0 2 .89 2 2h1c0-1.65-1.35-3-3-3m0 2c-.55 0-1 .45-1 1s.45 1 1 1s1-.45 1-1s-.45-1-1-1\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiRssAlt: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M0 0v2c3.33 0 6 2.67 6 6h2c0-4.41-3.59-8-8-8m0 3v2c1.67 0 3 1.33 3 3h2c0-2.75-2.25-5-5-5m0 3v2h2a2 2 0 0 0-2-2\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiScript: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M3 0c-.55 0-1 .45-1 1v5.5c0 .28-.22.5-.5.5S1 6.78 1 6.5V5H0v2c0 .55.45 1 1 1h5c.55 0 1-.45 1-1V4H3V1.5c0-.28.22-.5.5-.5s.5.22.5.5V3h4V1c0-.55-.45-1-1-1z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiShare: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M5 0v2C1 2 0 4.05 0 7c.52-1.98 2-3 4-3h1v2l3-3.16z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiShareBoxed: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M.75 0C.34 0 0 .34 0 .75v5.5c0 .41.34.75.75.75h4.5c.41 0 .75-.34.75-.75V5H5v1H1V1h2V0zM6 0v1C3.95 1 2.3 2.54 2.06 4.53C2.27 3.65 3.05 3 4 3h2v1l2-2z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiShield: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m4 0l-.19.09l-3.5 1.47l-.31.13V2c0 1.66.67 3.12 1.47 4.19c.4.53.83.97 1.25 1.28S3.55 8 4 8c.46 0 .86-.22 1.28-.53s.85-.75 1.25-1.28C7.33 5.12 8 3.66 8 2v-.31l-.31-.13L4.19.09zm0 1.09V7c-.04 0-.33-.07-.66-.31s-.71-.63-1.06-1.09a6.26 6.26 0 0 1-1.22-3.28L4 1.1z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiSignal: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M6 0v8h1V0zM4 1v7h1V1zM2 3v5h1V3zM0 5v3h1V5z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiSignpost: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M3 0v1H1L0 2l1 1h2v5h1V4h2l1-1l-1-1H4V0z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiSortAscending: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M2 0v6H0l2.5 2L5 6H3V0zm2 0v1h2V0zm0 2v1h3V2zm0 2v1h4V4z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiSortDescending: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M2 0v6H0l2.5 2L5 6H3V0zm2 0v1h4V0zm0 2v1h3V2zm0 2v1h2V4z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiSpreadsheet: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M.75 0C.34 0 0 .34 0 .75v5.5c0 .41.34.75.75.75h6.5c.41 0 .75-.34.75-.75V.75C8 .34 7.66 0 7.25 0zM1 1h1v1H1zm2 0h4v1H3zM1 3h1v1H1zm2 0h4v1H3zM1 5h1v1H1zm2 0h4v1H3z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiStar: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M4 0L3 3H0l2.5 2l-1 3L4 6l2.5 2l-1-3L8 3H5z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiSun: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M4 0c-.28 0-.5.22-.5.5s.22.5.5.5s.5-.22.5-.5S4.28 0 4 0M1.5 1c-.28 0-.5.22-.5.5s.22.5.5.5s.5-.22.5-.5s-.22-.5-.5-.5m5 0c-.28 0-.5.22-.5.5s.22.5.5.5s.5-.22.5-.5s-.22-.5-.5-.5M4 2c-1.1 0-2 .9-2 2s.9 2 2 2s2-.9 2-2s-.9-2-2-2M.5 3.5c-.28 0-.5.22-.5.5s.22.5.5.5s.5-.22.5-.5s-.22-.5-.5-.5m7 0c-.28 0-.5.22-.5.5s.22.5.5.5s.5-.22.5-.5s-.22-.5-.5-.5M1.5 6c-.28 0-.5.22-.5.5s.22.5.5.5s.5-.22.5-.5s-.22-.5-.5-.5m5 0c-.28 0-.5.22-.5.5s.22.5.5.5s.5-.22.5-.5s-.22-.5-.5-.5M4 7c-.28 0-.5.22-.5.5s.22.5.5.5s.5-.22.5-.5S4.28 7 4 7\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiTablet: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M.34 0A.35.35 0 0 0 0 .34v7.31c0 .18.16.34.34.34h6.31c.18 0 .34-.16.34-.34V.34A.35.35 0 0 0 6.65 0zM1 1h5v5H1zm2.5 5.5c.38 0 .63.42.44.75s-.68.33-.88 0c-.19-.33.05-.75.44-.75\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiTag: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M0 0v3l5 5l3-3l-5-5zm2 1c.55 0 1 .45 1 1s-.45 1-1 1s-1-.45-1-1s.45-1 1-1\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiTags: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M0 1v2l3 3l1.5-1.5L5 4L3 2L2 1zm3.41 0l3 3l-1.19 1.22L6 6l2-2l-3-3zM1.5 2c.28 0 .5.22.5.5s-.22.5-.5.5s-.5-.22-.5-.5s.22-.5.5-.5\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiTarget: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M4 0C1.8 0 0 1.8 0 4s1.8 4 4 4s4-1.8 4-4s-1.8-4-4-4m0 1c1.66 0 3 1.34 3 3S5.66 7 4 7S1 5.66 1 4s1.34-3 3-3m0 1c-1.1 0-2 .9-2 2s.9 2 2 2s2-.9 2-2s-.9-2-2-2m0 1c.56 0 1 .44 1 1s-.44 1-1 1s-1-.44-1-1s.44-1 1-1\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiTask: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M0 0v7h7V3.41l-1 1V6H1V1h3.59l1-1zm7 0L4 3L3 2L2 3l2 2l4-4z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiTerminal: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M.09 0C.03 0 0 .04 0 .09V7.9c0 .05.04.09.09.09H7.9c.05 0 .09-.04.09-.09V.09C7.99.03 7.95 0 7.9 0zM1.5.78L3.22 2.5L1.5 4.22L.78 3.5l1-1l-1-1zM4 3h3v1H4z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiText: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M0 0v2h.5c0-.55.45-1 1-1H3v5.5c0 .28-.22.5-.5.5H2v1h4V7h-.5c-.28 0-.5-.22-.5-.5V1h1.5c.55 0 1 .45 1 1H8V0z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiThumbDown: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M0 0v4h1V0zm2 0v4c.28 0 .53.09.72.28S3.87 6.4 4 6.66s.39.39.66.31c.26-.08.4-.36.31-.63c-.08-.26-.47-1.59-.47-1.84S4.72 4 5 4h1.5c.28 0 .5-.22.5-.5S5.97.31 5.97.31A.52.52 0 0 0 5.5 0z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiThumbUp: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M4.47 0C4.28.02 4.1.15 4 .34C3.87.6 2.91 2.53 2.72 2.72S2.28 3 2 3v4h3.5c.21 0 .39-.13.47-.31C5.97 6.69 7 3.78 7 3.5S6.78 3 6.5 3H5c-.28 0-.5-.25-.5-.5S4.89.92 4.97.66a.504.504 0 0 0-.31-.63C4.59.01 4.54-.01 4.47 0M0 3v4h1V3z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiTimer: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M2 0v1h1v.03A3.503 3.503 0 0 0 3.5 8C5.43 8 7 6.43 7 4.5c0-.45-.1-.87-.25-1.25l-.91.38c.11.29.16.57.16.88c0 1.39-1.11 2.5-2.5 2.5S1 5.9 1 4.51s1.11-2.5 2.5-2.5c.3 0 .59.05.88.16l.34-.94c-.23-.08-.47-.12-.72-.16v-.06h1v-1H2zm5 1.16s-3.65 2.81-3.84 3c-.19.2-.19.49 0 .69s.49.2.69 0s3.16-3.69 3.16-3.69z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiTransfer: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M6 0v1H0v1h6v1l2-1.5zM2 4L0 5.5L2 7V6h6V5H2z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiTrash: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M3 0c-.55 0-1 .45-1 1H1c-.55 0-1 .45-1 1h7c0-.55-.45-1-1-1H5c0-.55-.45-1-1-1zM1 3v4.81c0 .11.08.19.19.19h4.63c.11 0 .19-.08.19-.19V3h-1v3.5c0 .28-.22.5-.5.5s-.5-.22-.5-.5V3h-1v3.5c0 .28-.22.5-.5.5s-.5-.22-.5-.5V3h-1z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiUnderline: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M1 0v4c0 1.1 1.12 2 2.5 2H4c1.1 0 2-.9 2-2V0H5v4c0 .55-.45 1-1 1s-1-.45-1-1V0zM0 7v1h7V7z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiVerticalAlignBottom: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M.09 0C.03 0 0 .04 0 .09V4.9c0 .05.04.09.09.09H1.9c.05 0 .09-.04.09-.09V.09C1.99.03 1.95 0 1.9 0zm6 0A.09.09 0 0 0 6 .09V4.9c0 .05.04.09.09.09H7.9c.05 0 .09-.04.09-.09V.09C7.99.03 7.95 0 7.9 0zm-3 2c-.06 0-.09.04-.09.09V4.9c0 .05.04.09.09.09H4.9c.05 0 .09-.04.09-.09V2.09c0-.06-.04-.09-.09-.09zM0 6v1h8V6z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiVerticalAlignCenter: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M.09 0C.03 0 0 .04 0 .09V2h2V.09C2 .03 1.96 0 1.91 0H.1zm6 0A.09.09 0 0 0 6 .09V2h2V.09C8 .03 7.96 0 7.91 0H6.1zm-3 1c-.06 0-.09.04-.09.09V2h2v-.91A.09.09 0 0 0 4.91 1H3.1zM0 3v1h8V3zm0 2v1.91c0 .05.04.09.09.09H1.9c.05 0 .09-.04.09-.09V5h-2zm3 0v.91c0 .05.04.09.09.09H4.9c.05 0 .09-.04.09-.09V5h-2zm3 0v1.91c0 .05.04.09.09.09H7.9c.05 0 .09-.04.09-.09V5h-2z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiVerticalAlignTop: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M0 0v1h8V0zm.09 2C.03 2 0 2.04 0 2.09V6.9c0 .05.04.09.09.09H1.9c.05 0 .09-.04.09-.09V2.09c0-.06-.04-.09-.09-.09zm3 0c-.06 0-.09.04-.09.09V4.9c0 .05.04.09.09.09H4.9c.05 0 .09-.04.09-.09V2.09c0-.06-.04-.09-.09-.09zm3 0a.09.09 0 0 0-.09.09V6.9c0 .05.04.09.09.09H7.9c.05 0 .09-.04.09-.09V2.09c0-.06-.04-.09-.09-.09z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiVideo: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M.5 1c-.28 0-.5.23-.5.5v4c0 .28.23.5.5.5h5c.28 0 .5-.22.5-.5V4l1 1h1V2H7L6 3V1.5c0-.28-.22-.5-.5-.5z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiVolumeHigh: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M3.34 0L2 2H0v4h2l1.34 2H4V0zM5 1v1c.17 0 .34.02.5.06c.86.22 1.5 1 1.5 1.94a1.987 1.987 0 0 1-2 2v1c.25 0 .48-.04.72-.09h.03C7.05 6.58 8 5.4 8 4s-.95-2.58-2.25-2.91C5.52 1.03 5.26 1 5 1m0 2v2c.09 0 .18-.01.25-.03c.43-.11.75-.51.75-.97a.997.997 0 0 0-1-1\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiVolumeLow: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M4.34 0L3 2H1v4h2l1.34 2H5V0zM6 3v2c.09 0 .18-.01.25-.03c.43-.11.75-.51.75-.97a.997.997 0 0 0-1-1\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiVolumeOff: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M5.34 0L4 2H2v4h2l1.34 2H6V0z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiWarning: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M3.09 0c-.06 0-.1.04-.13.09L.02 6.9c-.02.05-.03.13-.03.19v.81c0 .05.04.09.09.09h6.81c.05 0 .09-.04.09-.09v-.81c0-.05-.01-.14-.03-.19L4.01.09A.14.14 0 0 0 3.88 0h-.81zM3 3h1v2H3zm0 3h1v1H3z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiWifi: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M3.75 0C2.37 0 1.09.4 0 1.09l.53.81c.93-.59 2.03-.91 3.22-.91c1.2 0 2.32.31 3.25.91l.53-.81C6.44.39 5.13 0 3.75 0m0 3c-.79 0-1.5.23-2.13.63l.53.84c.47-.3 1-.47 1.59-.47s1.16.17 1.63.47l.53-.84C5.28 3.24 4.53 3 3.74 3zm0 3c-.55 0-1 .45-1 1s.45 1 1 1s1-.45 1-1s-.45-1-1-1\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiWrench: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M5.5 0A2.5 2.5 0 0 0 3 2.5c0 .32.08.62.19.91L.28 6.29c-.39.39-.39 1.05 0 1.44c.2.2.46.28.72.28s.52-.09.72-.28L4.6 4.82c.28.11.58.19.91.19a2.5 2.5 0 0 0 2.5-2.5c0-.16 0-.32-.03-.47l-.97.97h-2v-2l.97-.97C5.83.01 5.67.01 5.51.01zM1 6.5c.28 0 .5.22.5.5s-.22.5-.5.5S.5 7.28.5 7s.22-.5.5-.5\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiX: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M1.41 0L0 1.41l.72.72L2.5 3.94L.72 5.72L0 6.41l1.41 1.44l.72-.72l1.81-1.81l1.78 1.81l.69.72l1.44-1.44l-.72-.69l-1.81-1.78l1.81-1.81l.72-.72L6.41 0l-.69.72L3.94 2.5L2.13.72z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiYen: Icon = {
  "body": "<path fill=\"currentColor\" d=\"m0 0l2.25 3H0v1h3v1H0v1h3v2h1V6h3V5H4V4h3V3H4.75L7 0H6L3.69 3h-.38L1 0z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiZoomIn: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M3.5 0C1.57 0 0 1.57 0 3.5S1.57 7 3.5 7c.61 0 1.19-.16 1.69-.44a1 1 0 0 0 .09.13l1 1.03a1.02 1.02 0 1 0 1.44-1.44l-1.03-1a1 1 0 0 0-.13-.09c.27-.5.44-1.08.44-1.69C7 1.57 5.43 0 3.5 0m0 1C4.89 1 6 2.11 6 3.5c0 .59-.2 1.14-.53 1.56l-.03.03l-.06.03a1 1 0 0 0-.25.28c-.44.37-1.01.59-1.63.59c-1.39 0-2.5-1.11-2.5-2.5S2.11.99 3.5.99zM3 2v1H2v1h1v1h1V4h1V3H4V2z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}

export const oiZoomOut: Icon = {
  "body": "<path fill=\"currentColor\" d=\"M3.5 0C1.57 0 0 1.57 0 3.5S1.57 7 3.5 7c.61 0 1.19-.16 1.69-.44a1 1 0 0 0 .09.13l1 1.03a1.02 1.02 0 1 0 1.44-1.44l-1.03-1a1 1 0 0 0-.13-.09c.27-.5.44-1.08.44-1.69C7 1.57 5.43 0 3.5 0m0 1C4.89 1 6 2.11 6 3.5c0 .59-.2 1.14-.53 1.56l-.03.03l-.06.03a1 1 0 0 0-.25.28c-.44.37-1.01.59-1.63.59c-1.39 0-2.5-1.11-2.5-2.5S2.11.99 3.5.99zM2 3v1h3V3z\"/>",
  "width": 8,
  "height": 8,
  "viewBox": "0 0 8 8"
}